import { FC, useEffect, useMemo, useState } from 'react'
import { updateInvoices } from '../utils/api';
import { toast } from 'react-toastify';
import { useOrganization } from '../contexts/OrganizationContext';
import { useFirebaseQuery } from '../hooks/firebaseHooks';
import { OngoingInvoice } from '../models/shared/OngoingInvoice';
import { COLLECTIONS } from '../utils/shared/constants';
import { GoodsOwner } from '../models/shared/GoodsOwner';
import InvoiceTable from '../components/InvoiceTable';
import PageHeader from '../components/PageHeader';
import { Spinner } from 'react-bootstrap';

interface IProps { }

/**
* @author
* @function @TestPage
**/

interface InvoiceGroup {
    goodsOwner: GoodsOwner,
    invoices: OngoingInvoice[],
}

export const InvoicesPage: FC<IProps> = (props) => {
    const organization = useOrganization();
    const [processing, setProcessing] = useState(false);
    const [invoices] = useFirebaseQuery<OngoingInvoice>(`${COLLECTIONS.ORGANIZATIONS}/${organization.id}/${COLLECTIONS.INVOICES}`);

    useEffect(() => {
        const asyncEffect = async () => {
            setProcessing(true);
            try {
                await updateInvoices();
            } catch (error) {
                console.error(error);
                toast.error('Failed to update invoices');
            }
            setProcessing(false);
        }
        asyncEffect();
    }, [])


    const invoiceGroups = useMemo(() => {
        const groups: InvoiceGroup[] = [];
        for (const goodsOwner of organization.goodsOwners) {
            const invoicesForOwner = invoices.filter(invoice => invoice.goodsOwner.id === goodsOwner.id);
            groups.push({ goodsOwner, invoices: invoicesForOwner });
        }

        return groups

    }, [invoices, organization.goodsOwners]);


    return (
        <>
            <PageHeader title='Invoices' description='Manage your invoices from different goods owners.'
                titleSuffix={processing ? <Spinner animation="border" size="sm" className='ms-2' /> : null}
            />

            <div className='d-flex flex-column gap-4'>


                {invoiceGroups.map((group, ix) => <InvoiceTable ix={ix} key={ix} goodsOwner={group.goodsOwner} invoices={group.invoices} />)}
            </div>
        </>

    )
}
